// extracted by mini-css-extract-plugin
export var layoutContainer = "_d6-0";
export var layoutContainerNoRounding = "_d6-6";
export var layoutContainerOpen = "_d6-5";
export var layoutContainerResizing = "_d6-1";
export var mainContent = "_d6-2";
export var resizeDivider = "_d6-3";
export var slidePanel = "_d6-4";